import React from 'react';
import { motion } from 'framer-motion';
import logoImg from '../../../assets/logo/logo-aib.png';

/**
 * Brand logo for StudieBijbaan.nl
 * Replaced original SVG with the official brand PNG logo
 */
const Logo = ({ size = 36, className = '' }) => {
  const px = typeof size === 'number' ? `${size}px` : size;
  
  return (
    <motion.img
      src={logoImg}
      alt="Studiebijbaan.nl logo"
      style={{ height: px, width: 'auto' }}
      className={`object-contain ${className}`}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    />
  );
};

export default Logo;


